import { TranslateService } from '@ngx-translate/core';

export interface SidebarMenuItem {
    label: string;
    icon?: string;
    routerLink?: string | unknown[];
    children?: SidebarMenuItem[];
    isHeader?: boolean;
    isBottom?: boolean;
    testId?: string;
}

export function createMenuItems(translate: TranslateService): SidebarMenuItem[] {
    return [
        // Dashboard - single item, no header
        {
            label: translate.instant('sidebar.dashboard'),
            icon: 'pi pi-objects-column',
            routerLink: '/dashboard',
            testId: 'nav-dashboard',
        },
        // System header - Administrators
        {
            label: translate.instant('sidebar.system'),
            isHeader: true,
            children: [
                {
                    label: translate.instant('sidebar.admins'),
                    icon: 'pi pi-shield',
                    routerLink: '/admins',
                    testId: 'nav-admins',
                },
            ],
        },
        // Platform header - Users & Schools
        {
            label: translate.instant('sidebar.platform'),
            isHeader: true,
            children: [
                {
                    label: translate.instant('sidebar.users'),
                    icon: 'pi pi-users',
                    routerLink: '/users',
                    testId: 'nav-users',
                },
                {
                    label: translate.instant('sidebar.assessors'),
                    icon: 'pi pi-user-edit',
                    routerLink: '/assessors',
                },
                {
                    label: translate.instant('sidebar.schools'),
                    icon: 'pi pi-building',
                    routerLink: '/schools',
                    testId: 'nav-schools',
                },
                {
                    label: translate.instant('sidebar.organisations'),
                    icon: 'pi pi-sitemap',
                    routerLink: '/organisations',
                    testId: 'nav-organisations',
                },
                {
                    label: translate.instant('sidebar.news'),
                    icon: 'pi pi-megaphone',
                    routerLink: '/news',
                    testId: 'nav-news',
                },
            ],
        },
        // Learning Content header
        {
            label: translate.instant('sidebar.learning-content'),
            isHeader: true,
            children: [
                {
                    label: translate.instant('sidebar.pathways'),
                    icon: 'pi pi-directions',
                    routerLink: '/pathways',
                    testId: 'nav-pathways',
                },
                {
                    label: translate.instant('sidebar.predefinedPathways'),
                    icon: 'pi pi-compass',
                    routerLink: '/predefined-pathways',
                    testId: 'nav-predefined-pathways',
                },
                {
                    label: translate.instant('sidebar.packages'),
                    icon: 'pi pi-box',
                    routerLink: '/packages',
                    testId: 'nav-packages',
                },
                {
                    label: translate.instant('sidebar.licenses'),
                    icon: 'pi pi-key',
                    routerLink: '/licenses',
                    testId: 'nav-licenses',
                },
                {
                    label: translate.instant('sidebar.courses'),
                    icon: 'pi pi-book',
                    routerLink: '/courses',
                    testId: 'nav-courses',
                },
                {
                    label: translate.instant('sidebar.modules'),
                    icon: 'pi pi-th-large',
                    routerLink: '/modules',
                    testId: 'nav-modules',
                },
                {
                    label: translate.instant('sidebar.lessons'),
                    icon: 'pi pi-play-circle',
                    routerLink: '/lessons',
                    testId: 'nav-lessons',
                },
                {
                    label: translate.instant('sidebar.quizzes'),
                    icon: 'pi pi-question-circle',
                    routerLink: '/quizzes',
                    testId: 'nav-quizzes',
                },
                {
                    label: translate.instant('sidebar.reflections'),
                    icon: 'pi pi-comments',
                    routerLink: '/reflections',
                },
            ],
        },
        // Media & Materials header
        {
            label: translate.instant('sidebar.media-and-materials'),
            isHeader: true,
            children: [
                {
                    label: translate.instant('sidebar.media'),
                    icon: 'pi pi-images',
                    routerLink: '/media',
                    testId: 'nav-media',
                },
                {
                    label: translate.instant('sidebar.quiz-questions'),
                    icon: 'pi pi-list-check',
                    routerLink: '/quiz-questions',
                    testId: 'nav-quiz-questions',
                },
            ],
        },
        // People header - Instructors
        {
            label: translate.instant('sidebar.people'),
            isHeader: true,
            children: [
                {
                    label: translate.instant('sidebar.instructors'),
                    icon: 'pi pi-user',
                    routerLink: '/instructors',
                    testId: 'nav-instructors',
                },
            ],
        },
        // Integrations header - Xero
        {
            label: translate.instant('sidebar.integrations'),
            isHeader: true,
            children: [
                {
                    label: translate.instant('sidebar.xero'),
                    icon: 'pi pi-sync',
                    routerLink: '/xero',
                    testId: 'nav-xero',
                },
            ],
        },
        // Bottom items
        {
            label: translate.instant('sidebar.storybook'),
            icon: 'pi pi-palette',
            isBottom: true,
            testId: 'nav-storybook',
            children: [
                {
                    label: translate.instant('sidebar.storybook.uploader'),
                    icon: 'pi pi-upload',
                    routerLink: '/storybook/uploader',
                    testId: 'nav-storybook-uploader',
                },
                {
                    label: translate.instant('sidebar.storybook.form-radio'),
                    icon: 'pi pi-circle',
                    routerLink: '/storybook/form-radio',
                    testId: 'nav-storybook-form-radio',
                },
                {
                    label: translate.instant('sidebar.storybook.store-map'),
                    icon: 'pi pi-sitemap',
                    routerLink: '/storybook/store-map',
                    testId: 'nav-storybook-store-map',
                },
            ],
        },
        {
            label: translate.instant('sidebar.settings'),
            icon: 'pi pi-cog',
            routerLink: '/settings',
            isBottom: true,
            testId: 'nav-settings',
        },
        {
            label: translate.instant('sidebar.profile'),
            icon: 'pi pi-user',
            routerLink: '/profile',
            isBottom: true,
            testId: 'nav-profile',
        },
    ];
}
